/* Amboras storefront interactions. All cart requests use Shopify's locale-aware root. */
(function () {
  'use strict';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const path = (suffix) => root + suffix;
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  const cartError = document.querySelector('[data-cart-error]');
  let returnFocus = null;
  let currentCurrency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';

  function money(cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currentCurrency }).format(Number(cents) / 100); }
    catch (_) { return (Number(cents) / 100).toFixed(2); }
  }
  function escapeText(value) {
    const node = document.createElement('span');
    node.textContent = String(value == null ? '' : value);
    return node.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function safeImage(src) {
    if (typeof src !== 'string' || !/^(https?:\/\/|\/)/i.test(src)) return '';
    if (src.startsWith('//')) src = 'https:' + src;
    return escapeText(src);
  }
  function showError(message) {
    if (!cartError) return;
    cartError.textContent = message;
    cartError.classList.toggle('hidden', !message);
  }
  async function request(suffix, options) {
    const response = await fetch(path(suffix), options);
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Please try again.');
    return data;
  }
  function countBadge(count) {
    document.querySelectorAll('[data-cart-count]').forEach((badge) => {
      badge.textContent = count;
      badge.classList.toggle('hidden', count === 0);
    });
  }
  function renderCart(cart) {
    if (!drawer) return;
    currentCurrency = cart.currency || currentCurrency;
    countBadge(cart.item_count);
    const itemsWrap = drawer.querySelector('[data-cart-items]');
    const footer = drawer.querySelector('[data-cart-footer]');
    if (!itemsWrap) return;
    if (!cart.items || cart.items.length === 0) {
      itemsWrap.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p><a href="' + escapeText(path('collections/all')) + '" class="btn btn-secondary">Start shopping</a></div>';
      if (footer) footer.classList.add('hidden');
      return;
    }
    if (footer) footer.classList.remove('hidden');
    itemsWrap.innerHTML = cart.items.map((item) => {
      const key = escapeText(item.key);
      const image = safeImage(item.image);
      return '<div class="cart-line-item">' +
        (image ? '<img src="' + image + '" alt="' + escapeText(item.product_title) + '" loading="lazy">' : '') +
        '<div style="flex:1"><div class="cart-line-item__title">' + escapeText(item.product_title) + '</div>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<div>' + escapeText(item.variant_title) + '</div>' : '') +
        '<div class="cart-line-item__controls"><div class="quantity-selector">' +
        '<button type="button" data-cart-minus data-key="' + key + '" aria-label="Decrease quantity">−</button>' +
        '<span data-cart-qty="' + key + '" style="min-width:24px;text-align:center">' + Number(item.quantity) + '</span>' +
        '<button type="button" data-cart-plus data-key="' + key + '" aria-label="Increase quantity">+</button></div>' +
        '<button type="button" class="cart-line-item__remove" data-cart-remove data-key="' + key + '">Remove</button></div></div>' +
        '<div>' + money(item.final_line_price) + '</div></div>';
    }).join('');
    const subtotal = drawer.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = money(cart.items_subtotal_price);
  }
  async function refreshCart() { renderCart(await request('cart.js')); }
  function openCart() {
    if (!drawer || !overlay) return;
    returnFocus = document.activeElement;
    drawer.classList.add('open');
    overlay.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('[data-cart-close]').focus();
  }
  function closeCart() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus();
  }
  if (drawer && overlay) {
    refreshCart().catch(() => { showError('Could not load your cart. Please refresh the page.'); });
    document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', async () => {
      showError(''); openCart();
      try { await refreshCart(); } catch (_) { showError('Could not load your cart. Please refresh the page.'); }
    }));
    document.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeCart));
    overlay.addEventListener('click', closeCart);
    document.addEventListener('keydown', (event) => {
      if (!drawer.classList.contains('open')) return;
      if (event.key === 'Escape') closeCart();
      if (event.key === 'Tab') {
        const focusable = Array.from(drawer.querySelectorAll('button:not([disabled]), a[href], input:not([disabled])'));
        if (!focusable.length) return;
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    drawer.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-cart-remove], [data-cart-plus], [data-cart-minus]');
      if (!button) return;
      event.preventDefault();
      const key = button.dataset.key;
      const qty = drawer.querySelectorAll('[data-cart-qty]');
      const current = Array.from(qty).find((el) => el.dataset.cartQty === key);
      if (!current) return;
      const oldCount = Number(current.textContent);
      const next = button.hasAttribute('data-cart-remove') ? 0 : Math.max(0, oldCount + (button.hasAttribute('data-cart-plus') ? 1 : -1));
      showError(''); button.disabled = true;
      try {
        const cart = await request('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: next }) });
        renderCart(cart);
      } catch (error) { showError(error.message); button.disabled = false; }
    });
  }

  const toggle = document.querySelector('[data-mobile-nav-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    nav.addEventListener('click', (event) => { if (event.target.closest('a')) { nav.classList.remove('open'); toggle.setAttribute('aria-expanded', 'false'); } });
  }

  document.querySelectorAll('[data-quantity-selector]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelector('[data-qty-minus]')?.addEventListener('click', () => { input.value = Math.max(1, Number(input.value || 1) - 1); });
    wrap.querySelector('[data-qty-plus]')?.addEventListener('click', () => { input.value = Math.max(1, Number(input.value || 1) + 1); });
  });
  const mainImage = document.querySelector('[data-gallery-main] img');
  document.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
    if (!mainImage) return;
    mainImage.src = thumb.dataset.fullSrc;
    mainImage.alt = thumb.querySelector('img')?.alt || mainImage.alt;
    document.querySelectorAll('[data-gallery-thumb]').forEach((other) => other.classList.remove('active'));
    thumb.classList.add('active');
  }));
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const select = form.querySelector('[data-variant-select]');
    const submit = form.querySelector('[data-add-button]');
    const priceEl = document.querySelector('[data-product-price]');
    const stickyPrice = document.querySelector('[data-sticky-add-bar] div div');
    const stickyButton = document.querySelector('[data-sticky-add-button]');
    function syncVariant() {
      if (!select || !submit || !priceEl) return;
      const option = select.selectedOptions[0];
      const available = option.dataset.available === 'true';
      const price = Number(option.dataset.price);
      const compare = Number(option.dataset.comparePrice);
      submit.disabled = !available;
      if (stickyButton) stickyButton.disabled = !available;
      submit.textContent = available ? 'Add to Cart' : 'Sold Out';
      priceEl.innerHTML = money(price) + (compare > price ? ' <span class="compare-at">' + money(compare) + '</span>' : '');
      if (stickyPrice) stickyPrice.textContent = money(price);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState({}, '', url);
    }
    if (select) select.addEventListener('change', syncVariant);
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!submit || submit.disabled) return;
      submit.disabled = true;
      submit.textContent = 'Adding…';
      try {
        await request('cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        await refreshCart(); openCart();
      } catch (error) {
        showError(error.message);
        if (drawer) openCart(); else window.alert(error.message);
      } finally {
        const selected = select?.selectedOptions[0];
        submit.disabled = selected ? selected.dataset.available !== 'true' : false;
        submit.textContent = submit.disabled ? 'Sold Out' : 'Add to Cart';
      }
    });
  });
  const stickyBar = document.querySelector('[data-sticky-add-bar]');
  const primaryButton = document.querySelector('[data-product-form] [data-add-button]');
  const stickyButton = document.querySelector('[data-sticky-add-button]');
  if (stickyBar && primaryButton && stickyButton && 'IntersectionObserver' in window) {
    new IntersectionObserver((entries) => { stickyBar.classList.toggle('visible', !entries[0].isIntersecting); }).observe(primaryButton);
    stickyButton.addEventListener('click', () => { if (primaryButton.disabled) { primaryButton.scrollIntoView({ behavior: 'smooth' }); return; } primaryButton.click(); });
  }
})();
